import {Routes} from '@angular/router'
import {adminAuthGuard} from '@sparbanken-syd/sparbanken-syd-bankid'
import {userResolver} from './application/user.resolver'
import {HomeComponent} from './home/home.component'
import {BASE_PATH, LOGIN_PATH} from './services/types'

export const routes: Routes = [
  {
    path: BASE_PATH,
    loadChildren: () => import('./base/base.routes'),
    canActivate: [adminAuthGuard],
    resolve: {
      users: userResolver
    }
  },
  {
    path: LOGIN_PATH,
    component: HomeComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]